export type MediaType = "movie" | "tv" | "variety";

export interface Movie {
  id: string;
  title: string;
  type: MediaType;
  genres: string[];
  region: string;
  year: number;
  rating: number;
  duration: string;
  director: string;
  cast: string[];
  synopsis: string;
  cover: string;
  views: number;
  featured: boolean;
  tagline: string;
  heroImage?: string;
}

export const mediaTypeLabels: Record<MediaType, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};

export const genreOptions = ["动作", "剧情", "悬疑", "科幻", "犯罪", "惊悚", "爱情", "历史", "纪录", "美食", "音乐", "竞技"];

export const regionOptions = ["欧美", "亚洲", "华语", "日韩"];

export const yearOptions = ["2024", "2023", "2022", "2021"];

export const hotKeywords = ["午夜列车", "星尘之下", "悬疑", "深夜食堂秀", "霓虹深渊", "帝国黄昏"];

export const movies: Movie[] = [
  {
    id: "1",
    title: "暗夜追踪",
    type: "movie",
    genres: ["悬疑", "动作"],
    region: "欧美",
    year: 2024,
    rating: 8.6,
    duration: "128分钟",
    director: "亚瑟·雷恩",
    cast: ["艾琳·卡特", "马库斯·格雷", "索菲亚·洛"],
    synopsis: "午夜的城市霓虹闪烁，一名私家侦探循着一条断续的线索，在无人知晓的街巷中追逐真相。当每一盏路灯都像在隐瞒什么时，他必须在天亮之前找到那个消失的证人。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20movie%20poster%20background%2C%20lone%20detective%20silhouette%20in%20dark%20rainy%20city%20street%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20dramatic%20composition%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-01&orientation=portrait",
    views: 284500,
    featured: true,
    tagline: "每一个夜晚，都藏着未被讲述的真相",
    heroImage: "https://readdy.ai/api/search-image?query=cinematic%20wide%20midnight%20cityscape%20with%20lone%20figure%20walking%20through%20rain%20and%20neon%20reflections%2C%20deep%20navy%20blue%20sky%20with%20warm%20orange%20street%20glow%2C%20stylized%20artistic%20atmospheric%20lighting%2C%20high%20detail%2C%20dramatic%20moody%20composition%2C%20no%20text&width=1600&height=900&seq=midnight-hero-01&orientation=landscape",
  },
  {
    id: "2",
    title: "霓虹深渊",
    type: "movie",
    genres: ["科幻", "悬疑"],
    region: "欧美",
    year: 2023,
    rating: 8.2,
    duration: "116分钟",
    director: "娜奥米·维克",
    cast: ["卢卡斯·芬", "伊莎贝尔·诺", "丹·阿什"],
    synopsis: "在一座由数据构成的城市里，记忆是可以被交易的商品。当一个程序员发现自己的过去被人为抹去，他决定潜入城市最深处的那片霓虹，寻找被删掉的自己。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20movie%20poster%20background%2C%20neon%20cyberpunk%20city%20abyss%20with%20glowing%20grid%20and%20vertical%20lights%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-02&orientation=portrait",
    views: 221800,
    featured: false,
    tagline: "被删掉的记忆，还在深渊里发光",
  },
  {
    id: "3",
    title: "午夜列车",
    type: "movie",
    genres: ["惊悚", "悬疑"],
    region: "亚洲",
    year: 2024,
    rating: 7.9,
    duration: "104分钟",
    director: "崔志勋",
    cast: ["金秀妍", "朴泰宇", "郑恩熙"],
    synopsis: "一列在午夜发车、没有终点站的列车，载着七名互不相识的乘客。当第一位乘客在隧道中消失，剩下的六个人必须在下一站到来之前，找出谁才是真正买票上车的人。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20movie%20poster%20background%2C%20old%20night%20train%20emerging%20from%20a%20dark%20tunnel%20with%20faint%20windows%20glow%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-03&orientation=portrait",
    views: 198300,
    featured: true,
    tagline: "这趟车，没有终点站",
    heroImage: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20lone%20night%20train%20crossing%20a%20dark%20bridge%20under%20a%20starry%20midnight%20sky%2C%20deep%20navy%20blue%20tones%20with%20warm%20orange%20window%20glow%2C%20stylized%20artistic%20atmospheric%20lighting%2C%20high%20detail%2C%20dramatic%20moody%20composition%2C%20no%20text&width=1600&height=900&seq=midnight-hero-03&orientation=landscape",
  },
  {
    id: "4",
    title: "孤城谍影",
    type: "movie",
    genres: ["动作", "犯罪"],
    region: "华语",
    year: 2022,
    rating: 8.8,
    duration: "136分钟",
    director: "陈立言",
    cast: ["周廷", "林晚", "高志远"],
    synopsis: "战后的孤城里，每个人都在扮演别人。一个身份成谜的男人在午夜接头，却发现自己要见的人已经在三天前死去。他必须在各方势力的夹缝中，拼出最后一块碎片。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20movie%20poster%20background%2C%20solitary%20spy%20in%20a%20rainy%20old%20city%20alley%20with%20tall%20shadowy%20buildings%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-04&orientation=portrait",
    views: 176500,
    featured: false,
    tagline: "在这座孤城里，没有人是真的",
  },
  {
    id: "5",
    title: "星尘之下",
    type: "movie",
    genres: ["科幻", "剧情"],
    region: "欧美",
    year: 2024,
    rating: 9.1,
    duration: "142分钟",
    director: "海伦·卡斯特",
    cast: ["诺亚·布莱克", "米娅·罗兰", "奥利弗·松"],
    synopsis: "地球即将告别最后的夜晚，一队科学家踏上寻找新家园的旅程。当他们抵达那颗星球时，才发现真正要面对的，是自己对离开与留下的选择。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20movie%20poster%20background%2C%20lone%20astronaut%20silhouette%20against%20a%20vast%20starry%20cosmos%20and%20glowing%20nebula%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-05&orientation=portrait",
    views: 342100,
    featured: true,
    tagline: "我们仰望的星尘，正是我们即将成为的过去",
    heroImage: "https://readdy.ai/api/search-image?query=cinematic%20wide%20cosmic%20scene%20with%20deep%20navy%20blue%20starfield%20nebula%20and%20a%20distant%20tiny%20planet%20glowing%20warm%20orange%2C%20stylized%20artistic%20atmospheric%20lighting%2C%20high%20detail%2C%20dramatic%20moody%20composition%2C%20no%20text&width=1600&height=900&seq=midnight-hero-05&orientation=landscape",
  },
  {
    id: "6",
    title: "沉默证人",
    type: "movie",
    genres: ["犯罪", "悬疑"],
    region: "欧美",
    year: 2021,
    rating: 8.0,
    duration: "112分钟",
    director: "格雷格·沃森",
    cast: ["埃米·斯通", "杰克·里德", "克拉拉·贝尔"],
    synopsis: "一名法医在午夜接到一具无名尸体，唯一的线索是死者手中攥着的一张老照片。随着调查深入，她发现照片上的每一个人都在隐瞒同一件事。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20movie%20poster%20background%2C%20foggy%20empty%20city%20street%20at%20night%20with%20a%20single%20street%20lamp%20glow%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-06&orientation=portrait",
    views: 154200,
    featured: false,
    tagline: "死者不会说话，但照片会",
  },
  {
    id: "7",
    title: "长夜将尽",
    type: "movie",
    genres: ["剧情"],
    region: "亚洲",
    year: 2023,
    rating: 8.4,
    duration: "121分钟",
    director: "林知远",
    cast: ["许安然", "江牧", "苏彤"],
    synopsis: "一个深夜仍在跑车的出租车司机，遇到了一个想去海边的乘客。这一夜，两个陌生人交换了各自不愿提起的过往，直到天边泛白。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20movie%20poster%20background%2C%20empty%20highway%20at%20night%20leading%20toward%20a%20faint%20orange%20dawn%20on%20the%20horizon%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-07&orientation=portrait",
    views: 187600,
    featured: false,
    tagline: "天亮之前，我们还可以好好说说话",
  },
  {
    id: "8",
    title: "逆光而行",
    type: "movie",
    genres: ["剧情"],
    region: "华语",
    year: 2024,
    rating: 7.7,
    duration: "108分钟",
    director: "何蔚",
    cast: ["宋知夏", "陆屿", "方晴"],
    synopsis: "一个曾经站在舞台中央的舞者，在意外后重新学习走路。深夜的排练厅里，她对着镜子一次次站起来，只为再次迎着光走出那一步。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20movie%20poster%20background%2C%20lone%20figure%20backlit%20by%20a%20warm%20orange%20spotlight%20in%20a%20dark%20empty%20studio%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-08&orientation=portrait",
    views: 132400,
    featured: false,
    tagline: "逆着光，也要走完这一步",
  },
  {
    id: "9",
    title: "迷城的雾",
    type: "tv",
    genres: ["悬疑", "犯罪"],
    region: "华语",
    year: 2024,
    rating: 8.9,
    duration: "共24集",
    director: "郑川",
    cast: ["沈砚", "林樱", "程野"],
    synopsis: "一座常年被雾笼罩的城市，每隔七年就会发生一起无解的案件。新任刑警队长在调查第一起案件时，发现线索竟指向了自己七岁那年的那场大雾。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20tv%20poster%20background%2C%20misty%20city%20skyline%20with%20faint%20windows%20glowing%20through%20thick%20fog%20at%20night%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-09&orientation=portrait",
    views: 312800,
    featured: true,
    tagline: "雾散之后，真相才刚开始",
    heroImage: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20misty%20city%20skyline%20at%20midnight%20with%20warm%20orange%20window%20lights%20glowing%20through%20blue%20fog%2C%20stylized%20artistic%20atmospheric%20lighting%2C%20high%20detail%2C%20dramatic%20moody%20composition%2C%20no%20text&width=1600&height=900&seq=midnight-hero-09&orientation=landscape",
  },
  {
    id: "10",
    title: "暗流",
    type: "tv",
    genres: ["犯罪", "剧情"],
    region: "欧美",
    year: 2023,
    rating: 8.5,
    duration: "共16集",
    director: "保罗·哈特",
    cast: ["本·福斯特", "安娜·克莱", "德里克·朗"],
    synopsis: "一座看似平静的港口城市，水面之下暗流涌动。当一批货物的失踪牵扯出多方势力，一个普通的水手被卷入了比他想象中更深的漩涡。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20tv%20poster%20background%2C%20dark%20night%20harbor%20with%20reflections%20on%20rippling%20water%20and%20distant%20lights%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-10&orientation=portrait",
    views: 205600,
    featured: false,
    tagline: "水面之下，才是真正的故事",
  },
  {
    id: "11",
    title: "霓虹之夏",
    type: "tv",
    genres: ["爱情", "剧情"],
    region: "日韩",
    year: 2024,
    rating: 7.8,
    duration: "共12集",
    director: "渡边翔",
    cast: ["小林凛", "山田悠", "佐藤葵"],
    synopsis: "在一个霓虹灯永不熄灭的夏天里，两名在便利店值夜班的年轻人，用一整季的深夜对话，慢慢靠近了彼此的孤独。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20tv%20poster%20background%2C%20neon%20lit%20convenience%20store%20window%20on%20a%20quiet%20summer%20night%20street%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-11&orientation=portrait",
    views: 168900,
    featured: false,
    tagline: "整个夏天，我们都只在深夜见面",
  },
  {
    id: "12",
    title: "破晓行动",
    type: "tv",
    genres: ["动作", "惊悚"],
    region: "欧美",
    year: 2022,
    rating: 8.1,
    duration: "共20集",
    director: "瑞恩·科尔",
    cast: ["杰森·梅", "劳拉·文", "凯文·斯"],
    synopsis: "一支特别行动小组接到的每一次任务，都在破晓前结束。但当他们发现目标名单上出现了自己的名字，这场在夜色中进行的行动彻底变了味。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20tv%20poster%20background%2C%20special%20ops%20team%20silhouettes%20moving%20through%20a%20dark%20urban%20night%20alley%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-12&orientation=portrait",
    views: 189400,
    featured: false,
    tagline: "天一亮，这场行动就不存在了",
  },
  {
    id: "13",
    title: "静默病房",
    type: "tv",
    genres: ["惊悚", "悬疑"],
    region: "华语",
    year: 2024,
    rating: 8.3,
    duration: "共18集",
    director: "钱奕",
    cast: ["温言", "顾清", "白露"],
    synopsis: "一间位于走廊尽头的病房，每晚都会少一位病人。新来的夜班护士开始记录每一次消失的细节，却发现自己也在名单之中。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20tv%20poster%20background%2C%20dim%20empty%20hospital%20corridor%20at%20night%20with%20flickering%20overhead%20lights%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-13&orientation=portrait",
    views: 176300,
    featured: false,
    tagline: "下一个消失的，会是谁",
  },
  {
    id: "14",
    title: "帝国黄昏",
    type: "tv",
    genres: ["历史", "剧情"],
    region: "欧美",
    year: 2021,
    rating: 9.0,
    duration: "共30集",
    director: "爱德华·诺顿",
    cast: ["威廉·海", "伊丽莎白·克", "托马斯·恩"],
    synopsis: "一个横跨大陆的帝国，在最后一个皇帝登基的那天开始走向黄昏。从宫廷密谋到边境烽火，这是一部关于权力、忠诚与衰落的史诗。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20tv%20poster%20background%2C%20ancient%20stone%20empire%20palace%20silhouette%20under%20a%20deep%20dusk%20sky%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-14&orientation=portrait",
    views: 264700,
    featured: true,
    tagline: "帝国从不一夜崩塌，黄昏总来得悄无声息",
    heroImage: "https://readdy.ai/api/search-image?query=cinematic%20wide%20epic%20scene%20of%20an%20ancient%20empire%20palace%20at%20deep%20twilight%20with%20warm%20orange%20torchlight%20against%20deep%20navy%20blue%20sky%2C%20stylized%20artistic%20atmospheric%20lighting%2C%20high%20detail%2C%20dramatic%20moody%20composition%2C%20no%20text&width=1600&height=900&seq=midnight-hero-14&orientation=landscape",
  },
  {
    id: "15",
    title: "城市边缘",
    type: "tv",
    genres: ["剧情"],
    region: "华语",
    year: 2023,
    rating: 7.9,
    duration: "共22集",
    director: "孟川",
    cast: ["叶南", "赵未", "罗沁"],
    synopsis: "城市的边缘住着一群早出晚归的人。各自的故事在深夜的公交末班车上交汇，拼出一幅关于普通人生活的温柔群像。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20tv%20poster%20background%2C%20last%20night%20bus%20at%20a%20quiet%20city%20outskirt%20stop%20with%20a%20single%20warm%20lamp%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-15&orientation=portrait",
    views: 143800,
    featured: false,
    tagline: "城市的边缘，也有灯一直亮着",
  },
  {
    id: "16",
    title: "午夜电台",
    type: "variety",
    genres: ["纪录", "音乐"],
    region: "华语",
    year: 2024,
    rating: 8.2,
    duration: "每期60分钟",
    director: "林沐",
    cast: ["主持：顾声", "嘉宾：谢言"],
    synopsis: "一档在午夜零点准时开始的电台节目，每一期邀请一位嘉宾，只聊那些白天说不出口的故事，再放一首刚好听懂的歌。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20variety%20poster%20background%2C%20vintage%20radio%20studio%20microphone%20glowing%20in%20a%20dark%20room%20at%20night%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-16&orientation=portrait",
    views: 121500,
    featured: false,
    tagline: "零点之后，把话慢慢说完",
  },
  {
    id: "17",
    title: "深夜食堂秀",
    type: "variety",
    genres: ["美食", "纪录"],
    region: "日韩",
    year: 2024,
    rating: 8.7,
    duration: "每期45分钟",
    director: "中村翔太",
    cast: ["主厨：田中勇", "常驻：小林遥"],
    synopsis: "只在午夜开门的小食堂，每晚只做一道菜。老板用最简单的食材，招待每一位带着心事推门进来的深夜客人。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20variety%20poster%20background%2C%20warm%20tiny%20late%20night%20food%20stall%20with%20rising%20steam%20in%20a%20dark%20alley%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-17&orientation=portrait",
    views: 233600,
    featured: false,
    tagline: "深夜的胃和心，都要被好好照顾",
  },
  {
    id: "18",
    title: "星夜现场",
    type: "variety",
    genres: ["音乐", "竞技"],
    region: "华语",
    year: 2023,
    rating: 9.2,
    duration: "每期90分钟",
    director: "苏野",
    cast: ["主持：周野", "嘉宾：众多音乐人"],
    synopsis: "一场只在星空下举办的现场音乐竞演。没有华丽的舞台，只有一把吉他、一片夜空，和那些愿意在午夜把歌唱完的人。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20music%20poster%20background%2C%20lone%20singer%20on%20an%20open%20stage%20under%20a%20vast%20starry%20night%20sky%20with%20warm%20lights%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-18&orientation=portrait",
    views: 298200,
    featured: false,
    tagline: "把歌，唱给整片星空听",
  },
  {
    id: "19",
    title: "极限夜跑",
    type: "variety",
    genres: ["竞技", "纪录"],
    region: "亚洲",
    year: 2024,
    rating: 7.6,
    duration: "每期70分钟",
    director: "吴桐",
    cast: ["领队：陈越", "选手：多人"],
    synopsis: "六座城市，六段夜跑路线。选手们要在午夜零点到黎明之间，穿过城市的街巷与天桥，用脚步丈量每一座城市沉睡后的样子。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20variety%20poster%20background%2C%20runners%20silhouettes%20on%20a%20night%20city%20bridge%20with%20motion%20and%20streetlights%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-19&orientation=portrait",
    views: 97800,
    featured: false,
    tagline: "零点出发，跑进城市的梦里",
  },
  {
    id: "20",
    title: "诡宅",
    type: "movie",
    genres: ["惊悚", "悬疑"],
    region: "华语",
    year: 2023,
    rating: 7.4,
    duration: "98分钟",
    director: "夏戈",
    cast: ["黎静", "韩沉", "阮清"],
    synopsis: "一对年轻夫妇搬进一栋郊外的老宅，夜晚总能听见楼上传来脚步声。当他们打开那扇从未上锁的门，才发现房子里住着的，是过去的自己。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20horror%20poster%20background%2C%20creepy%20old%20mansion%20at%20night%20with%20one%20lit%20window%20and%20bare%20trees%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-20&orientation=portrait",
    views: 142900,
    featured: false,
    tagline: "那扇门，从来没有锁上过",
  },
  {
    id: "21",
    title: "雪夜列车",
    type: "movie",
    genres: ["剧情", "悬疑"],
    region: "欧美",
    year: 2022,
    rating: 8.3,
    duration: "118分钟",
    director: "英格丽·索恩",
    cast: ["艾利克斯·波", "玛尔塔·林", "乔恩·维"],
    synopsis: "一场大雪让整列夜车停在荒原中央。车厢里的乘客各自带着秘密，当有人提出要重新分配座位时，这一夜注定无人入眠。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20movie%20poster%20background%2C%20snow%20covered%20night%20train%20stopped%20in%20a%20vast%20dark%20plain%20with%20glowing%20windows%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-21&orientation=portrait",
    views: 159700,
    featured: false,
    tagline: "雪停了之前，谁也别想下车",
  },
  {
    id: "22",
    title: "幻影之城",
    type: "tv",
    genres: ["科幻", "悬疑"],
    region: "欧美",
    year: 2024,
    rating: 8.6,
    duration: "共16集",
    director: "马克·丹尼",
    cast: ["卢娜·佩", "亚当·瑞", "伊芙·柯"],
    synopsis: "这座城市每天午夜都会重置一次。只有少数人记得昨天发生的一切，而他们必须在下一次重置前，找到让城市停下循环的方法。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20tv%20poster%20background%2C%20surreal%20futuristic%20city%20glowing%20with%20grids%20under%20a%20dark%20sky%20with%20floating%20light%20particles%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-22&orientation=portrait",
    views: 241300,
    featured: false,
    tagline: "午夜零点，城市又一次忘记了你",
  },
  {
    id: "23",
    title: "雾都疑案",
    type: "tv",
    genres: ["悬疑", "犯罪"],
    region: "欧美",
    year: 2023,
    rating: 8.8,
    duration: "共20集",
    director: "克莱尔·霍",
    cast: ["亨利·福", "玛格丽特·贝", "欧文·唐"],
    synopsis: "在常年多雾的老城里，一位退休探长被请回警局，只为解开一桩封存了二十年的旧案。雾越来越浓，真相却始终只露出一角。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20tv%20poster%20background%2C%20foggy%20old%20european%20street%20with%20gas%20lamps%20glowing%20in%20blue%20night%20mist%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-23&orientation=portrait",
    views: 219400,
    featured: false,
    tagline: "雾散之前，真相只露出一角",
  },
  {
    id: "24",
    title: "夜行记",
    type: "variety",
    genres: ["纪录", "剧情"],
    region: "华语",
    year: 2024,
    rating: 8.0,
    duration: "每期55分钟",
    director: "程野",
    cast: ["讲述：顾南"],
    synopsis: "摄制组跟随镜头走进城市的深夜，记录那些在别人睡着之后才开始工作的人。他们的夜晚，构成了城市另一半的模样。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20midnight%20documentary%20poster%20background%2C%20lone%20street%20sweeper%20silhouette%20in%20an%20empty%20night%20city%20with%20long%20shadows%2C%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%20accents%2C%20stylized%20artistic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20no%20lettering&width=600&height=900&seq=midnight-poster-24&orientation=portrait",
    views: 108200,
    featured: false,
    tagline: "别人睡着之后，城市才开始呼吸",
  },
];